import { render, staticRenderFns } from "./GridReport.vue?vue&type=template&id=80661d16&scoped=true&"
import script from "./GridReport.vue?vue&type=script&lang=js&"
export * from "./GridReport.vue?vue&type=script&lang=js&"
import style0 from "./GridReport.vue?vue&type=style&index=0&id=80661d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80661d16",
  null
  
)

export default component.exports